// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AgentSettingsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Agent settings response — returned by GET /ai/agent-settings.
 *
 * Consumed by ai-agent-service HttpAgentSettingsClient which reads
 * dados.ai_max_context (int|null) from the standard envelope.
 *
 * null means the setting row is absent or empty; the agent applies its
 * own default. A positive integer caps the LLM conversation-history
 * context window for the requesting user.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_AgentSettingsResponseDados {
ai_max_context?: number
}

export type AiCredits_AgentSettingsResponse = ApiResponse<AiCredits_AgentSettingsResponseDados>;

registerResponseContract('AiCredits_AgentSettingsResponse', {
  ai_max_context: { type: 'number',  required: false },
})
